import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, del, get, HasPagingParameters, patch, post } from "@insite/client-framework/Services/ApiService";
import { PunchoutServiceCollectionModel, PunchoutServiceModel } from "@TKCCP/Types/ApiModels";

export interface GetPunchoutApiParameter extends ApiParameter, HasPagingParameters {
    sort?: string;
    query?: string;
    expand?: "top3products"[];
    additionalExpands?: string[];
    filter?: string;
}

export interface AddPunchoutParameter extends ApiParameter {
    punchoutmodel: PunchoutServiceModel;
    // onSuccess?: (punchoutModel: PunchoutServiceModel) => void;
    // onError?: (errorMessage: string) => void;
}

export interface DeletePunchoutParameter extends ApiParameter {
    id: string;
    onSuccess?: () => void;
    // punchoutmodel: PunchoutServiceModel;
}

const punchoutUrl = "/api/v1/PunchOutSecretController";

export async function getPunchoutList(parameter: GetPunchoutApiParameter): Promise<PunchoutServiceCollectionModel> {
    // can't send empty status array to API
    const lists = await get<PunchoutServiceCollectionModel>(`${punchoutUrl}/all`, parameter);
    return lists;
}

export async function addPunchoutSecret(parameter: AddPunchoutParameter) {
    const punchoutmodel = parameter.punchoutmodel;
    const model = await patch<PunchoutServiceModel>(`${punchoutUrl}/add`, parameter.punchoutmodel);
    return model;
}

export async function deletePunchoutSecret(parameter: DeletePunchoutParameter) {
    const result = await del(`${punchoutUrl}/delete/${parameter.id}`);
    return result;
}
